import * as React from 'react'
import { Navigate }  from 'react-router-dom'
import { Grid, Typography, Box, Button} from '@mui/material'
import { round } from '../../../misc/other'
import axios from 'axios'
import DashboardIcon from '@mui/icons-material/Dashboard'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import { ErrorAlert } from '../../../alerts/ErrorAlert'
import { axiosErrorHandling } from '../../../misc/other'





export const AdminMoneyOrder = ({paymentInfo, totalDue})=>{
    
    const path = '/admin/dashboard'
    const totalDueplus5 =  round(totalDue + 5)

    const [goHome, setGotoHome]= React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [gotoProcessPayment, setGotoProcessPayment] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
   
    
const errorClose = () =>{
    setError(false)
}
    
    
    

    
    const onClick = () =>{
        setLoading(true)
        axios({
            method: 'POST',
            url: 'api/oracle3/moneyorder',
            data:{data: paymentInfo.accounts,
                  balance: totalDueplus5,
                  promo_code_used: paymentInfo.accounts[0].promo_code_used
             } 
        }).then(result=>{
            
            if(result.data==="Pending MoneyOrder"){
                setLoading(false)
                setGotoHome(true)
            } else{
            setLoading(false)
            setError(true)
            setErrorMessage('Something went wrong in the money order call')    
            }
        }).catch(err=>{
            let errMessage = axiosErrorHandling(err)
            setLoading(false)
            setErrorMessage(errMessage)
            setError(true)
            
        })

    }
    
    if (goHome){
        return <Navigate  to={path}/>
    }

    if (gotoProcessPayment){
        return (<Navigate to='physicalpayment' state={{totalDue:totalDueplus5, paymentInfo:paymentInfo}}/>)
    }

  const clickProcessPayment = () =>{
    setGotoProcessPayment(true)
  }

    
    
    return(
        
        <Box sx={{minHeight:'40vh', mt: 2}}>
            <ErrorAlert error={errorMessage} open={error} handleClose={errorClose}/>
        <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
        <Grid size={{xs: 10}}>
        <Typography sx ={{mb: 4}} variant='h6'gutterBottom={true}> Read to customer:  To complete payment by money order, make the money order out
                                          to NameMySettlement.com with the amount of ${totalDueplus5}. Which is your total due plus $5 for processing. Please send the Money Order to the following address, PO Box 15333, Spokane Valley, WA 99215. Please include your offer 
                                          letter in the envelope or your customer number on the memo portion of the money order.  It is best to send the Money Order certified mail with a return on receipt service to verify that 
                                          we have received the Money Order. Once received we will send you an invoice. </Typography>
        </Grid>
        </Grid>
        <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center'}}>
        <Grid sx={{m: 2}}>
        <Button sx={{mr: 2,}} loading={loading} onClick={onClick} loadingPosition='end' endIcon={<DashboardIcon/>} variant='contained' color='primary'> Go Back to Account Home</Button>    
        <Button variant='contained' color='secondary' onClick={clickProcessPayment} endIcon={<PaidOutlinedIcon/>}>Process Payment</Button>
        </Grid>
        
        </Grid>
        
        
        </Box>
        
        
    
    )

}